import {
  Checkbox,
  Col,
  Divider,
  Form,
  FormProps,
  Icons,
  Input,
  Radio,
  Row,
  Select,
} from '@pankod/refine-antd'
import { debounce } from 'lodash'
import React from 'react'

import { useParticipantFilterContext } from 'src/hooks/context/useParticipantFilterOptionsContext'
import { kapabilitasMapper } from './utils'
import {
  SelectCityOptions,
  SelectDistrictOptions,
  SelectProvinceOptions,
} from '@resources/basic-ppg-management/lptk/blocks/SelectLPTKDataOptions'
const { SearchOutlined } = Icons

type SideFilterParticipantFormProps = {
  children: React.ReactNode
  searchRowChildren?: React.ReactNode
  formInstance?: FormProps
  programId?: string
  withClassRoleFilter?: boolean
}

const PARTICIPANT_FILTER_OPTIONS = [
  {
    label: 'Semua',
    value: '',
  },
  {
    label: 'Asisten',
    value: 'asisten',
  },
  {
    label: 'Fasilitator',
    value: 'instruktur',
  },
  {
    label: 'Peserta',
    value: 'peserta',
  },
  {
    label: 'Admin Kelas',
    value: 'admin_kelas',
  },
]

// TODO: MAKE THIS REUSABLE
// TODO: REFACTOR THIS
export const SideFilterParticipantForm = ({
  children,
  searchRowChildren,
  formInstance,
  withClassRoleFilter = false,
}: SideFilterParticipantFormProps) => {
  const [searchType, setSearchType] = React.useState('name')
  const { data: filterOptions } = useParticipantFilterContext()

  const handleDebounceSubmit = debounce(() => {
    formInstance?.form?.setFieldsValue({
      searchMode: searchType,
    })

    formInstance?.form?.submit()
  }, 500)

  const filterKodeProvinsi = Form.useWatch('kodeProvinsi', formInstance?.form)
  const filterKodeKabupaten = Form.useWatch('kodeKabupaten', formInstance?.form)

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <Form layout="vertical" {...formInstance}>
          <Form.Item name="searchMode" hidden />
          <p className="text-xs font-bold  mb-2">Cari Peserta</p>
          <Form.Item name="searchQuery" className="w-[25vw]">
            <Input
              onChange={() => {
                handleDebounceSubmit()
              }}
              addonBefore={
                <Select
                  defaultValue="name"
                  onChange={(e) => {
                    setSearchType(e)
                  }}
                >
                  <Select.Option value="name">Nama</Select.Option>
                  <Select.Option value="email">Email</Select.Option>
                </Select>
              }
              placeholder={`Cari berdasarkan ${
                searchType === 'name' ? 'nama' : 'email'
              }`}
              prefix={<SearchOutlined className="mr-4" />}
              allowClear
            />
          </Form.Item>
        </Form>
        {withClassRoleFilter && (
          <Form layout="vertical" {...formInstance}>
            <p className="text-xs font-bold  mb-2 text-end">Tipe Peserta</p>
            <Form.Item name="roleKelas" className="">
              <Radio.Group
                options={PARTICIPANT_FILTER_OPTIONS}
                onChange={() => handleDebounceSubmit()}
                optionType="button"
                buttonStyle="outline"
                defaultValue={''}
                className="text-right"
              />
            </Form.Item>
          </Form>
        )}
        {searchRowChildren && searchRowChildren}
      </div>
      <Form layout="vertical" {...formInstance}>
        <p className="text-xs font-bold  mb-2">Filter Wilayah</p>
        <Row gutter={8}>
          <Col span={8}>
            <Form.Item name="kodeProvinsi">
              <SelectProvinceOptions
                autoComplete="off"
                aria-autocomplete="none"
                showSearch
                visible
                allowClear
                onChange={() => {
                  formInstance?.form?.setFieldsValue({
                    kodeKabupaten: undefined,
                    kodeKecamatan: undefined,
                  })
                }}
                placeholder="Pilih Provinsi"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="kodeKabupaten">
              <SelectCityOptions
                autoComplete="off"
                aria-autocomplete="none"
                showSearch
                provinceId={filterKodeProvinsi}
                disabled={!filterKodeProvinsi}
                allowClear
                initialValue={
                  formInstance?.initialValues?.kodeKotaKab
                    ? {
                        city: {
                          name: formInstance.initialValues.kotaKab,
                          id: formInstance.initialValues.kodeKotaKab,
                        },
                      }
                    : undefined
                }
                onChange={() => {
                  formInstance?.form?.setFieldsValue({
                    kodeKecamatan: undefined,
                  })
                }}
                placeholder="Pilih Kota/Kabupaten"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="kodeKecamatan">
              <SelectDistrictOptions
                autoComplete="off"
                aria-autocomplete="none"
                showSearch
                kotaKabId={filterKodeKabupaten}
                disabled={!filterKodeKabupaten}
                allowClear
                initialValue={
                  formInstance?.initialValues?.kodeKecamatan
                    ? {
                        district: {
                          name: formInstance.initialValues.kecamatan,
                          id: formInstance.initialValues.kodeKecamatan,
                        },
                      }
                    : undefined
                }
                placeholder="Pilih Kecamatan"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Divider style={{ marginTop: 0 }} />
      <div className="flex flex-row">
        <div className="w-[10vw] mr-4  rounded">
          <div>
            <Form
              layout="vertical"
              {...formInstance}
              onValuesChange={() => {
                handleDebounceSubmit()
              }}
            >
              <p className="text-xs font-bold mt-4 mb-2">Kapabilitas</p>
              <Form.Item name="kapabilitas">
                <Checkbox.Group>
                  {filterOptions?.data?.kapabilitas?.map((item: any) => (
                    <Checkbox
                      key={item}
                      value={item}
                      style={{
                        marginLeft: '0px',
                        marginBottom: 8,
                        display: 'flex',
                      }}
                    >
                      {kapabilitasMapper(item)}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </Form.Item>
            </Form>
          </div>
        </div>
        <Divider type="vertical" style={{ height: '50vh' }} />
        <div className="w-[70vw] ml-2 overflow-x-auto">{children}</div>
      </div>
    </div>
  )
}
